/**
 * Hides the preload.
 * Call this when views are finished rendering.
 */
export function hidePreload() {
  (window as any).hidePreload();
}

export function isPreloadVisible() {
  return Boolean(document.querySelector('#preload:not(.done)'));
}